import {
    PiBriefcaseDuotone,
    PiCalendarCheckDuotone,
    PiCalendarXDuotone,
    PiFileTextDuotone,
    PiInfoDuotone,
    PiUserCircleDuotone,
} from 'react-icons/pi';

import PageHeading from 'elements/PageHeading';
import Pattern from 'elements/Pattern';

export default function StudentJobAppointmentPage() {
    return (
        <main className="relative flex min-h-screen w-full flex-col items-center overflow-hidden gradient-green px-site py-site">
            <Pattern className="pointer-events-none opacity-45" />

            <div className="relative z-10 flex w-full max-w-boxed flex-col gap-8">
                <PageHeading
                    title="Diákmunka időpontfoglalás"
                    subTitle="Tekintsd át és vállald el azokat a munkaidőpontokat, amelyekre már jogosult vagy jelentkezni."
                    align="left"
                    mobileAlign="center"
                />

                <section className="rounded-3xl border border-white/70 bg-white p-5 text-neutral-800 shadow-2xl sm:p-8 lg:p-10">
                    <header className="mb-7 flex items-center gap-3">
                        <span className="flex size-12 shrink-0 items-center justify-center rounded-xl bg-green-50 text-3xl text-green-600">
                            <PiBriefcaseDuotone />
                        </span>
                        <div>
                            <h2 className="font-display text-2xl font-black leading-tight text-neutral-900 sm:text-3xl">Munkára jelentkezés</h2>
                            <p className="mt-1 text-sm text-neutral-500">Az elérhető munkák és konkrét időpontok helye.</p>
                        </div>
                    </header>

                    <div className="grid gap-4 lg:grid-cols-3">
                        <InfoCard
                            icon={<PiFileTextDuotone />}
                            title="Szükséges dokumentumok"
                            description="Itt azok a lehetőségek jelennek meg, amelyekhez már megkaptad a tájékoztatást és aláírtad a szükséges dokumentumokat."
                        />
                        <InfoCard
                            icon={<PiCalendarCheckDuotone />}
                            title="Választható időpontok"
                            description="Csak azok a munkák és időpontok láthatók, amelyek vállalására a munka felelőse már jogosultságot adott neked."
                        />
                        <InfoCard
                            icon={<PiInfoDuotone />}
                            title="Fontos tudnivaló"
                            description="Nem minden elérhető munkaidőpont jelenik meg ezen az oldalon; egyes munkákra más folyamatban lehet jelentkezni."
                        />
                    </div>

                    <div className="mt-7 flex flex-col items-center rounded-3xl border border-neutral-200 bg-neutral-50 px-5 py-8 text-center sm:px-8 sm:py-10">
                        <span className="mb-4 flex size-16 items-center justify-center rounded-2xl bg-white text-4xl text-neutral-400 shadow-sm">
                            <PiCalendarXDuotone />
                        </span>
                        <h3 className="max-w-2xl font-display text-xl font-black text-neutral-900 sm:text-2xl">
                            Jelenleg nincs számodra megjeleníthető munkalehetőség
                        </h3>
                        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-neutral-600 sm:text-base">
                            Most nem tudsz konkrét munkaidőpontot vállalni. Amint új, számodra elérhető lehetőség érkezik, ezen az oldalon fog megjelenni.
                        </p>
                    </div>

                    <div className="mt-5 flex items-start gap-3 rounded-2xl bg-green-50 p-4 text-green-900 sm:p-5">
                        <PiUserCircleDuotone className="mt-0.5 size-6 shrink-0 text-green-600" />
                        <p className="text-sm leading-relaxed sm:text-base">
                            A további részletekért vagy a jogosultságoddal kapcsolatos kérdés esetén keresd a Fürge Diák kapcsolattartódat.
                        </p>
                    </div>
                </section>
            </div>
        </main>
    );
}

function InfoCard({ icon, title, description }) {
    return (
        <article className="rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm sm:p-5">
            <span className="mb-3 flex size-10 items-center justify-center rounded-xl bg-green-50 text-2xl text-green-600">
                {icon}
            </span>
            <h3 className="font-display text-base font-black text-neutral-900 sm:text-lg">{title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-neutral-600">{description}</p>
        </article>
    );
}
